module.exports = __webpack_public_path__ + "static/media/calendario.8f679af5.svg";